module.exports = __webpack_public_path__ + "static/img/summer_cheliziPic.cf7d4517.png";